import React from "react";
import { compose } from "recompose";
import { withRouter, Redirect } from "react-router-dom";
import { withTheme } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import { withUserProfile } from "../../userProfile/userProfileContext";
import { withSnackbar } from "notistack";
import DispatchHeader from "./dispatchHeader/index.js";
import IbplanningHeader from "./ibplanningHeader/index.js";
import appConstants from "../../appConstants";
import ShipmentSelectionHeader from "./shipmentSelectionHeader";

class AppHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dispatch: this.props.path.url.includes("dispatch")
    }
  }

  componentDidUpdate(){
    if (this.state.dispatch && this.props.path.url.includes("ibplanning/")){
      this.setState({
        dispatch: false
      })

    } else if (!this.state.dispatch && (this.props.path.url.includes("dispatch"))){
      this.setState({
        dispatch: true,
      });
    }
    
  }


  render() {
    const shipmentSelection = this.props.path.url.includes("shipmentselection");
    if (shipmentSelection) {
      return <ShipmentSelectionHeader path={this.props.match}
        glEventHub={this.props.glEventHub}
        featureFlags={this.props.featureFlags} />
    }
    const ModuleComponent = this.state.dispatch
      ? DispatchHeader
      : IbplanningHeader;
    return (
      <div>
        {this.state.dispatch &&
        !this.props.userData.userProfile.enableDispatch ? (
          <Redirect to={appConstants.NAV_URLS.ACCESS_DENIED} />
        ) : (
          <ModuleComponent
            path={this.props.match}
            glEventHub={this.props.glEventHub}
            featureFlags={this.props.featureFlags}
          />
        )}
      </div>
    );
  }
}
export default compose(
  withWidth(),
  withTheme(),
  withRouter,
  withUserProfile,
  withSnackbar
)(AppHeader);
